import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Items from './pages/Items';
import Customers from './pages/Customers';
import Vendors from './pages/Vendors';
import Transactions from './pages/Transactions';
import ResponsiveLayout from './components/ResponsiveLayout';
import RequireAuth from './components/RequireAuth';
import LoginPage from './pages/LoginPage';
import Display from './pages/Display';

function App() {
  return (
    <Router>
      <ResponsiveLayout>
        <Routes>
                    <Route path="/" element={
                      <RequireAuth><display /></RequireAuth>
                    } />
                    
                    <Route path="/login" element={<LoginPage />} />
                    
                    <Route path="/transactions" element={
                      <RequireAuth><Transactions /></RequireAuth>
                    } />
                    <Route path="/items" element={
                      <RequireAuth><Items /></RequireAuth>
                    } />
                    <Route path="/customers" element={
                      <RequireAuth><Customers /></RequireAuth>
                    } />
                    <Route path="/vendors" element={
                      <RequireAuth><Vendors /></RequireAuth>
                    } />
                    <Route path="/display" element={<Display />} />
        </Routes>
      </ResponsiveLayout>
    </Router>
  );
}

export default App;
